<template>
  <div class="page">
    <a-card title="请求限流">
      <a-form layout="vertical">
        <a-form-item label="开启限流">
          <a-switch v-model:checked="limit.enable" disabled />
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="时间窗口（秒）">
              <a-input-number v-model:value="limit.duration" :min="1" disabled style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="窗口内允许请求数">
              <a-input-number v-model:value="limit.requests" :min="1" disabled style="width: 100%" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <a-card class="mt" title="安全与登录">
      <a-form layout="vertical">
        <a-form-item label="JWT 过期时间（小时）">
          <a-input-number v-model:value="jwtExpireHours" :min="1" disabled style="width: 100%" />
          <div class="hint">刷新浏览器会自动刷新 Token，设置为 1~720 小时，默认 168 小时。</div>
        </a-form-item>
      </a-form>
    </a-card>

    <div class="actions">
      <span class="hint">这些系统配置现在由 `config.yaml` 管理，修改文件后重启服务生效。</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { getSystemConfig } from '@/api/TikuComponentApi'

export default defineComponent({
  name: 'SystemConfig',
  setup() {
    const limit = reactive({
      enable: false,
      duration: 3,
      requests: 1,
    })
    const jwtExpireHours = ref(168)

    const load = () => {
      getSystemConfig().then(res => {
        if (res?.status === 200 && res.data) {
          Object.assign(limit, res.data.limit || {})
          if (res.data.jwtExpireHours) {
            jwtExpireHours.value = res.data.jwtExpireHours
          }
        } else {
          message.error(res?.message || '加载失败')
        }
      })
    }

    onMounted(() => load())

    return {
      limit,
      jwtExpireHours,
    }
  }
})
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mt {
  margin-top: 12px;
}
.actions {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.hint {
  color: #888;
  font-size: 13px;
}
</style>
